module.exports = __webpack_public_path__ + "static/media/security.7e13a5d3.svg";